import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="top-center"
      className="toaster group"
      visibleToasts={3}
      closeButton={true}
      expand={true}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-md group-[.toaster]:w-[calc(100vw-32px)] group-[.toaster]:max-w-none group-[.toaster]:rounded-xl",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:font-semibold group-[.toast]:px-4 group-[.toast]:py-2",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success:
            "group-[.toaster]:bg-emerald-50 group-[.toaster]:text-emerald-800 group-[.toaster]:border-l-4 group-[.toaster]:border-l-emerald-500 group-[.toaster]:border-y-0 group-[.toaster]:border-r-0 dark:group-[.toaster]:bg-emerald-950/50 dark:group-[.toaster]:text-emerald-100",
          error:
            "group-[.toaster]:bg-red-50 group-[.toaster]:text-red-800 group-[.toaster]:border-l-4 group-[.toaster]:border-l-red-500 group-[.toaster]:border-y-0 group-[.toaster]:border-r-0 dark:group-[.toaster]:bg-red-950/50 dark:group-[.toaster]:text-red-100",
          info:
            "group-[.toaster]:bg-blue-50 group-[.toaster]:text-blue-800 group-[.toaster]:border-l-4 group-[.toaster]:border-l-blue-500 group-[.toaster]:border-y-0 group-[.toaster]:border-r-0 dark:group-[.toaster]:bg-blue-950/50 dark:group-[.toaster]:text-blue-100",
          warning:
            "group-[.toaster]:bg-amber-50 group-[.toaster]:text-amber-800 group-[.toaster]:border-l-4 group-[.toaster]:border-l-amber-500 group-[.toaster]:border-y-0 group-[.toaster]:border-r-0 dark:group-[.toaster]:bg-amber-950/50 dark:group-[.toaster]:text-amber-100",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
